/**
 * Date helper utilities
 * Single source for age calculation used across calculations, forms, and display.
 */

/** Calculate age from date of birth. Age in years, or null if dob is falsy. */
export function calculateAge(dob: string | Date | null | undefined, refDate: Date | string = new Date()): number | null {
    if (!dob) return null;
    const birthDate = new Date(dob);
    const referenceDate = new Date(refDate);
    let age = referenceDate.getFullYear() - birthDate.getFullYear();
    const monthDiff = referenceDate.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && referenceDate.getDate() < birthDate.getDate())) {
        age--;
    }
    return age;
}
